import type { ComponentProps } from "react";

import { Breadcrumbs } from "@features/navigations/breadcrumbs";

import { Author } from "@shared/ui/author";
import { Image } from "@shared/ui/image";
import { Body, Heading } from "@shared/ui/typography";
import { formatDate } from "@shared/utils/string";

import type { ArticleHeroType } from "@/_pages/article/model";

import s from "./article-hero.module.scss";

export type ArticleHeroProps = ComponentProps<"div"> & {
  className?: string;
  data: ArticleHeroType;
  createdAt: string;
};

export const ArticleHero = (props: ArticleHeroProps) => {
  const {
    data: { title, timeToRead, author, mainImage },
    createdAt,
  } = props;

  return (
    <section className={s.root}>
      <div className={s.content}>
        <div className={s.left}>
          <Breadcrumbs className={s.breadcrumbs} />
          <Body size="uppercase-small" className={s.info}>
            <span>{formatDate(createdAt)}</span>
            {/* <span>&bull;</span>
            <span>{timeToRead ?? ""} чтения</span> */}
          </Body>
          {title && (
            <Heading tag="h1" level={3} className={s.title}>
              {title}
            </Heading>
          )}
        </div>
        {author && <Author data={author} />}
      </div>
      {mainImage?.url && (
        <Image
          src={mainImage.url}
          alt={mainImage?.alternativeText ?? "article main image"}
          className={s.image}
        />
      )}
    </section>
  );
};

ArticleHero.displayName = "ArticleHero";
